export const flattenCategories = (
  data: CategorySchema | CategorySchema[]
): CategorySchema[] => {
  data = Array.isArray(data) ? data : [data];
  const flattenCats = (cats: CategorySchema[]) => {
    const _cats = cats.reduce(
      (acc, cat) => {
        let children = [];
        if (cat.children) {
          children = flattenCats(cat.children);
          acc = [...acc, ...children];
        }
        return acc;
      },
      [...cats]
    );
    return _cats;
  };
  const cats = flattenCats(data);
  return cats;
};
